import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";

import StatusChip from "components/StatusChip";

const StatBlock = ({ label, children }) => (
  <Box display="flex" flexDirection="column" minWidth={70}>
    <Typography fontSize={12} color="text.secondary">
      {label}
    </Typography>
    {children}
  </Box>
);

const VendorInfoCard = ({ vendor, stats = [] }) => {
  const theme = useTheme();
  const isActive = String(vendor?.status).toUpperCase() === "ACTIVE";

  return (
    <Box
      data-testid="vendor-info-card"
      mt={4}
      p={4}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      gap={4}
      sx={{
        borderRadius: "12px",
        border: `1px solid ${theme.palette.grey["400"]}`,
        backgroundColor: theme.palette.info.lightBlueBackround,
      }}
    >
      <Box>
        <Typography fontWeight={600}>
          {[vendor?.vendor_name, vendor?.location_name]
            .filter(Boolean)
            .join(" · ")}
        </Typography>
        <Typography fontSize={14} color="text.secondary">
          {[vendor?.vendor_id, vendor?.state].filter(Boolean).join(" · ")}
        </Typography>
      </Box>

      <Box display="flex" alignItems="center" gap={8}>
        {/* TODO: status not in vendor search response, wire with vendor details API */}
        {vendor?.status && (
          <StatBlock label="Status">
            <StatusChip
              label={isActive ? "Active" : "Inactive"}
              type={isActive ? "SUCCESS" : "ERROR"}
            />
          </StatBlock>
        )}
        {stats.map(({ label, value }) => (
          <StatBlock key={label} label={label}>
            <Typography fontWeight={600}>{value ?? "-"}</Typography>
          </StatBlock>
        ))}
      </Box>
    </Box>
  );
};

StatBlock.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node,
};

VendorInfoCard.propTypes = {
  vendor: PropTypes.object.isRequired,
  stats: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.node,
    }),
  ),
};

export default VendorInfoCard;
